import { Alert, CloseButton, Link, Text, useDisclosure } from '@chakra-ui/react';
import React from 'react';

import { useI18n } from 'lib/i18n/context';

import { STATS_CHART_KEYS } from './i18n';

function ChartsLoadingErrorAlert() {
  const { t } = useI18n();
  const {
    isOpen: isVisible,
    onClose,
  } = useDisclosure({ defaultIsOpen: true });

  return isVisible ? (
    <Alert status="warning" mb={ 4 }>
      <Text mr={ 2 }>
        { t(STATS_CHART_KEYS.errors.chartsLoadFailed) }{ ' ' }
        <Link href={ window.document.location.href }>{ t(STATS_CHART_KEYS.actions.clickAgain) }</Link>
      </Text>

      <CloseButton
        alignSelf={{ base: 'flex-start', lg: 'center' }}
        ml="auto"
        onClick={ onClose }
      />
    </Alert>
  ) : null;
}

export default ChartsLoadingErrorAlert;
